module.exports = __webpack_public_path__ + "static/media/iso14001.e3f5e4f2.png";